









































































































































import { easing, styler, tween } from "popmotion";
import { Component, Vue } from "vue-property-decorator";
import { Constants, Console, Events } from "@/common/global.ts";

import BasePage from "@/common/base-page.ts";

@Component
export default class Datepicker extends BasePage {

    /**
     * [name description]
     *
     * @type {[type]}
     */
    public name: string = "page/datepicker";

    /**
     * [canGo description]
     *
     * @type {[type]}
     */
    private canGo: boolean = false;

    /**
     * [$experience description]
     *
     * @type {[type]}
     */
    private $experience: HTMLIFrameElement = <HTMLIFrameElement> document.querySelector("iframe");

    /**
     * We can thank IE for having to put these into JS instead of CSS
     *
     * @type {Number[]}
     */
    private percentages: number[] = [
        0, 14, 28, 42, 56,
        67, 78, 89, 100,
    ];

    /**
     * Line graph stages
     *
     * @type {[type]}
     */
    private stages: string[] = [
        "stage-0",
        "stage-0B",
        "stage-1",
        "stage-1B",
        "stage-2",
        "stage-2B",
        "stage-2C",
        "stage-2D",
        "stage-3",
    ];

    /**
     * [zodiac description]
     *
     * @type {[type]}
     */
    private zodiac: string[] = [
        "", "Capricorn", "Aquarius", "Pisces", "Aries", "Taurus",
        "Gemini", "Cancer", "Leo", "Virgo", "Libra", "Scorpio",
        "Sagittarius", "Capricorn",
    ];

    /**
     * [fieldOrder description]
     *
     * @type {[type]}
     */
    private fieldOrder: string[] = [
        "day", "month", "year",
    ];

    /**
     * [mounted description]
     *
     * @return {[type]} [description]
     */
    public mounted() {
        const $ref: HTMLInputElement = <HTMLInputElement> this.$refs.day;

        if (screen.width > 480) {
            $ref.focus();
        }
    }


    // Animation
    // -----------------------------------------------------------------

    /**
     * [AnimateOut description]
     *
     * @param {[type]} onComplete: any [description]
     */
    public AnimateOut(onComplete: any = null): void {
        super.AnimateOut();

        setTimeout(onComplete, 500);
    }

    /**
     * Reset All
     */
    public reset(): void {
        const day: HTMLInputElement = <HTMLInputElement> this.$refs.day;
        const month: HTMLInputElement = <HTMLInputElement> this.$refs.month;
        const year: HTMLInputElement = <HTMLInputElement> this.$refs.year;

        day.value = "";
        month.value = "";
        year.value = "";

        day.focus();
    }

    //
    // -----------------------------------------------------------------

    /**
     * gotoNextField
     *
     * @type {[type]}
     */
    protected gotoNextField($el: HTMLInputElement): void {
        const currentName: string = $el.getAttribute("data-name") || "day";
        const currentIndex: number = this.fieldOrder.indexOf(currentName);
        const nextIndex: number = Math.min(currentIndex + 1, this.fieldOrder.length);
        const nextName: string = this.fieldOrder[nextIndex];
        const $ref: HTMLInputElement = <HTMLInputElement> this.$refs[nextName];

        // mk: Timeout is an attempt to fix a mobile Edge bug
        if (nextName != null) {
            setTimeout(() => {
                $ref.focus();
            }, 100);
        }
    }

    /**
     * gotoPreviousField
     *
     * @type {[type]}
     */
    protected gotoPreviousField($el: HTMLInputElement): void {
        const currentName: string = $el.getAttribute("data-name") || "day";
        const currentIndex: number = this.fieldOrder.indexOf(currentName);
        const nextIndex: number = Math.max(currentIndex - 1, 0);
        const nextName: string = this.fieldOrder[nextIndex];
        const $ref: HTMLInputElement = <HTMLInputElement> this.$refs[nextName];

        // mk: Timeout is an attempt to fix a mobile Edge bug
        if ($ref) {
            setTimeout(() => {
                $ref.focus();
            }, 100);
        }
    }

    /**
     * [date description]
     *
     * @type {[type]}
     */
    private dateToZodiac(day: number, month: number): string {
        const lastDay: number[] = [
            0, 19, 18, 20, 20, 21, 21, 22, 22, 21, 22, 21, 20, 19,
        ];

        return (day > lastDay[month])
            ? this.zodiac[month * 1 + 1]
            : this.zodiac[month];
    }

    /**
     * Set stage of slider
     *
     * @type {[type]}
     */
    private setStageByIndex(index: number): void {
        this.unsetState("stage-0");
        this.unsetState("stage-1");
        this.unsetState("stage-2");
        this.unsetState("stage-3");
        this.setState("stage-" + index);
    }

    /**
     * Set stage by length of input
     *
     * @type {[type]}
     */
    private setStageByLength(): void {
        const day: string = (<HTMLInputElement> this.$refs.day).value;
        const month: string = (<HTMLInputElement> this.$refs.month).value;
        const year: string = (<HTMLInputElement> this.$refs.year).value;
        const total: number = day.length + month.length + year.length;
        const className: string = this.stages[total];
        const percentage: number = this.percentages[total];

        // Unset all
        this.stages.map((stage) => this.unsetState(stage));

        // Set stage
        this.setState(className);

        // mk: Hack for Edge
        if (/Edge\/\d./i.test(navigator.userAgent)) {
            const so: SVGElement = <SVGElement> document.querySelector("#FillMask");
            so.setAttributeNS(null, "width", percentage + "%");
        }

        // mk: Hack for Safari so it will recognize CSS changes made to it
        const svg: SVGElement = <SVGElement> document.querySelector("svg.progress-bar");

        svg.style.display = "flex";
        setTimeout(() => {
            svg.style.display = "block";
        }, 1);

        // Animate
        // const divStyler = styler(document.querySelector("#FillMask"));
        // const p: number = parseFloat(document.querySelector("#FillMask").getAttributeNS(null, "width") || "0");
        // console.log("Total", total, className, percentage, p);
        // tween({
        //     // from: {
        //     //     // width: p + "%",
        //     // },
        //     to: {
        //         width: (percentage / 100) * 800 + "px",
        //     },
        //     duration: 150,
        //     ease: easing.linear,
        // }).start(divStyler.set);
    }

    /**
     * validates birthday
     */
    private validateBirthday(day: number, month: number, year: number): boolean {
        const validDate: boolean = !isNaN(Date.parse([month, day, year].join("/")));
        const validYear: boolean = year <= (new Date()).getFullYear() && year >= 1900;

        console.log( day, month, year, validDate, validYear );

        return validDate && validYear;
    }

    /**
     *
     */
    private go(): void {
        const day: number = parseFloat((<HTMLInputElement> this.$refs.day).value) || 0;
        const month: number = parseFloat((<HTMLInputElement> this.$refs.month).value) || 0;
        const year: number = parseFloat((<HTMLInputElement> this.$refs.year).value) || 0;

        // Validate
        if (!this.validateBirthday(day, month, year)) {
            this.setState("invalid-birthdate");
            this.reset();
            return;
        }

        const zodiac: string = this.dateToZodiac(day, month);

        // Set birthday to window
        window[Constants.WINDOW_KEY_BIRTHDAY] = {
            day, month, year,
            eu_format: `${day}/${month}/${year}`,
            us_format: `${month}/${day}/${year}`,
        };

        // Set zodiac to window
        window[Constants.WINDOW_KEY_ZODIAC] = zodiac;

        // Log
        this.log(day, month, year, zodiac, "Set to window." + Constants.WINDOW_KEY_ZODIAC);

        // Goto experience
        this.$router.push("/experience");
    }


    // Event Handlers
    // -----------------------------------------------------------------

    /**
     * Disabled because of Safari, now things are all wonky.
     *
     * @type {[type]}
     */
    private Handle_OnClickGo(e: MouseEvent): void {
        e.preventDefault();

        // Go action
        this.go();
    }

    /**
     * Add extra zeros when leaving input
     *
     * @type {[type]}
     */
    private Handle_OnInputBlur(e: Event): void {
        const $el: HTMLInputElement = <HTMLInputElement> e.currentTarget;
        const value: string = $el.value.toString();
        const intVal: number = parseFloat(value);
        const maxValue: number = parseFloat($el.getAttribute("data-maxValue") || "1");
        const minValue: number = parseFloat($el.getAttribute("data-minValue") || "1");

        if (value.length === 1) {
            $el.value = "0" + value;
        }

        if (value !== "") {
            if (intVal < minValue || intVal > maxValue) {
                $el.value = "";
                console.warn("Value does not comopute");

                setTimeout(() => {
                    $el.focus();
                }, 250);
            }
        }
    }

    /**
     * Reset input on first focus
     *
     * @type {[type]}
     */
    private Handle_OnInputFocus(e: Event): void {
        const $el: HTMLInputElement = <HTMLInputElement> e.currentTarget;
        const index: number = parseFloat($el.getAttribute("data-index") || "0");

        // Reset value
        $el.value = "";

        // Set stage
        this.setStageByIndex(index);
    }

    private Handle_OnInputKeydown(e: KeyboardEvent): void {
        const $el: HTMLInputElement = <HTMLInputElement> e.currentTarget;
        const index: number = parseFloat($el.getAttribute("data-index") || "0");
        const KEY_BACKSPACE: number = 8;
        const KEY_TAB: number = 9;
        const KEY_ENTER: number = 13;

        // Unset state
        this.unsetState("invalid-birthdate");

        //  Go to next input
        if ($el.value === "" && e.keyCode === KEY_BACKSPACE) {
            this.gotoPreviousField($el);
            return;
        }

        // Check if we tabbed too early
        if ($el.value === "" && e.keyCode === KEY_TAB) {
            e.preventDefault();
            e.stopPropagation();
            return;
        }

        // On Enter
        if (e.keyCode === KEY_ENTER) {
            this.go();
            return;
        }

        if (
            (e.keyCode >= 48 && e.keyCode <= 57)
         || (e.keyCode >= 96 && e.keyCode <= 105)
         || (e.keyCode === KEY_TAB || e.keyCode === KEY_BACKSPACE)
        ) {
            // do nothing
        }
        else {
            e.preventDefault();
            return;
        }
    }

    private Handle_OnInputKeyup(e: KeyboardEvent): void {
        const $el: HTMLInputElement = <HTMLInputElement> e.currentTarget;
        const value: string = $el.value;
        const index: number = parseFloat($el.getAttribute("data-index") || "0");
        const maxLength: number = parseFloat($el.getAttribute("maxlength") || "2");
        const maxDigit: number = parseFloat($el.getAttribute("data-maxDigit") || "2");

        //  Go to next input
        if (parseFloat($el.value) >= maxDigit || $el.value.toString().length >= maxLength) {
            this.gotoNextField($el);

            if ($el.value.toString().length === 1) {
                $el.value = "0" + $el.value;
            }
        }

        // Is filled out
        // mk: timeout is for Safari
        setTimeout(() => {
            this.setStageByLength();
        }, 10);

        // Check validity
        this.canGo = (<HTMLFormElement> this.$refs.form).checkValidity();
    }

}
